import React, { Component } from 'react';
import FlatsListItem from '../FlatsListItem';
import s from '../styles';
import { withTranslation } from 'react-i18next';

class Flats extends Component {
  render() {
    const {
      finished,
      data,
      active,
      handleMoreClick,
      handleFlatClick,
      pavilions,
      building,
      showInfo,
      buildingForGallery,
      t,
      currency,
      selectionId,
      userUid,
      sessionId,
    } = this.props;
    return (
      <div className={s.FlatsList}>
        {data
          .filter((flat) => flat.status !== 'fundStatus' && flat.data.disabled != 1)
          .map((flat) => (
            <FlatsListItem
              {...flat}
              key={flat.flatId}
              handleFlatClick={handleFlatClick}
              active={flat.flatId === active}
              pavilions={pavilions}
              building={building}
              showInfo={showInfo}
              buildingForGallery={buildingForGallery}
              currency={currency}
              selectionId={selectionId}
              userUid={userUid}
              sessionId={sessionId}
            />
          ))}
        {!finished && (
          <button className={s.FlatsListShowMore} onClick={handleMoreClick}>
            {t('components.flatsList.flats.showMore')}
          </button>
        )}
      </div>
    );
  }
}

export default withTranslation()(Flats);



// WEBPACK FOOTER //
// ./src/components/FlatsList/Flats/Flats.js